import { Skeleton } from "@/components/ui/skeleton";

export function InsightsGridSkeleton() {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {/* Report Card Skeleton */}
      <div className="rounded-lg border bg-card p-6 flex flex-col min-h-[280px]">
        {/* Header */}
        <div className="flex items-start gap-4">
          <Skeleton className="h-12 w-12 rounded-lg" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        </div>

        {/* Preview Area */}
        <div className="mt-4 flex-1 flex items-center justify-center">
          <div className="w-full flex items-center justify-around py-4">
            <div className="text-center">
              <Skeleton className="h-10 w-12 mx-auto" />
              <Skeleton className="h-3 w-16 mx-auto mt-2" />
            </div>
            <div className="h-16 w-px bg-border" />
            <div className="text-center">
              <Skeleton className="h-8 w-20 mx-auto" />
              <Skeleton className="h-3 w-20 mx-auto mt-2" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-auto pt-4 border-t flex items-center justify-between">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}

export function InsightsPageSkeleton() {
  return (
    <div className="space-y-6">
      <div>
        <Skeleton className="h-9 w-32" />
        <Skeleton className="h-5 w-96 mt-2" />
      </div>
      <InsightsGridSkeleton />
    </div>
  );
}

